// alerts and sweeps constants.js
/**
 * @module Alerts and sweeps constants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const AlertsConstantFile
 */
export default keyMirror({
  NAVIGATION_REFERENCE: null,
  SET_MANAGE_ALERTS_ACCOUNT_ID: null,
});
